import { Input, Select, Button, Form } from "antd";
import { STATUS_TYPE, FORMS, BUTTONS } from "../common/constants";
import { useSelector } from "react-redux";

const CreateFleetForm = ({ orgId, vehicleList, isLoading, handleSubmit }) => {
  const orgDetails = useSelector((state) => state.org);
  const { Option } = Select;

  const getFormFieldRule = (field) => [
    {
      required: true,
      message: `Please Enter ${field}!`,
    },
  ];

  const statusType = [STATUS_TYPE.ACTIVE, STATUS_TYPE.INACTIVE];
  const formFields = [
    {
      label: FORMS.FLEETS.FIELDS.NAME.LABEL,
      name: FORMS.FLEETS.FIELDS.NAME.NAME,
      rules: getFormFieldRule(FORMS.FLEETS.FIELDS.NAME.LABEL),
      style: {},
    },
  ];

  return (
    <Form
      onFinish={handleSubmit}
      autoComplete="off"
      className="mt2"
      initialValues={{
        [FORMS.FLEETS.FIELDS.ORG_ID.NAME]: orgId,
      }}
    >
      {formFields.map((field, index) => (
        <Form.Item
          key={index}
          label={field.label}
          name={field.name}
          rules={field.rules}
          style={field.style}
          help={field.help}
        >
          <Input />
        </Form.Item>
      ))}
      <Form.Item
        name={FORMS.FLEETS.FIELDS.ORG_ID.NAME}
        label={FORMS.FLEETS.FIELDS.ORG_ID.LABEL}
        rules={getFormFieldRule(FORMS.FLEETS.FIELDS.ORG_ID.LABEL)}
      >
        <Select
          allowClear
          disabled
          maxTagCount={"responsive"}
          placeholder={FORMS.FLEETS.FIELDS.ORG_ID.PLACEHOLDER}
        >
          {orgDetails?.list?.map((org, index) => (
            <Option key={index} value={org.id}>
              {org.name}
            </Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        name={FORMS.FLEETS.FIELDS.VEHICLE_IMEI.NAME}
        label={FORMS.FLEETS.FIELDS.VEHICLE_IMEI.LABEL}
        rules={getFormFieldRule(FORMS.FLEETS.FIELDS.VEHICLE_IMEI.LABEL)}
      >
        <Select
          allowClear
          mode="multiple"
          maxTagCount={"responsive"}
          placeholder={FORMS.FLEETS.FIELDS.VEHICLE_IMEI.PLACEHOLDER}
          options={vehicleList}
          fieldNames={{
            label: "vehImei",
            value: "vehImei",
            // value: "vehId",
            options: "options",
          }}
        />
      </Form.Item>

      <Form.Item
        name={FORMS.FLEETS.FIELDS.STATUS.NAME}
        label={FORMS.FLEETS.FIELDS.STATUS.LABEL}
        rules={getFormFieldRule(FORMS.FLEETS.FIELDS.STATUS.LABEL)}
      >
        <Select placeholder={FORMS.FLEETS.FIELDS.STATUS.PLACEHOLDER}>
          {statusType.map((type, index) => (
            <Option key={index} value={type}>
              {type}
            </Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        name={FORMS.FLEETS.FIELDS.DESCRIPTION.NAME}
        label={FORMS.FLEETS.FIELDS.DESCRIPTION.LABEL}
      >
        <Input />
      </Form.Item>

      <Button type="primary" htmlType="submit" loading={isLoading}>
        {BUTTONS.CREATE}
      </Button>
    </Form>
  );
};

export default CreateFleetForm;
